import axios from 'axios';

export function fetchPartners() {
    return axios.get('/partners').then((partners) => {
        addFilteringMetadata(partners.data);
        return partners;
    });
}

export function fetchPartner(id) {
    return axios.get('/partners/' + id);
}

export function patchPartner(payload) {
    return axios.patch('/partners/' + payload.id, payload);
}

export function postAddRelation(payload) {
    return axios.post('/partners/' + payload.id + '/add-relation', payload);
}

export function postRemoveRelation(payload) {
    return axios.post('/partners/' + payload.id + '/remove-relation', payload);
}

function addFilteringMetadata(items) {
    for (var i = 0; i < items.length; i++) {
        items[i].filteringMetaData = items[i].clients.map((w) => w.name).join(' ');

        items[i].relationSortMetaData = items[i].affiliateCommission
            ? 1
            : items[i].inboundCommission
              ? 2
              : items[i].outboundCommission
                ? 3
                : 4;
    }
}
